<script setup lang="ts">
import EventClockMinuteInput from '@desktop/views/Relation/Sports/components/RelationView/Main/EventClock/EventClockMinuteInput.vue'
import EventClockPlayPauseButton from '@desktop/views/Relation/Sports/components/RelationView/Main/EventClock/EventClockPlayPauseButton.vue'
import EventClockSecondInput from '@desktop/views/Relation/Sports/components/RelationView/Main/EventClock/EventClockSecondInput.vue'
</script>

<template>
  <div
    class="border-neutral-light-0 bg-neutral-light-6 flex h-8 items-center rounded-sm border"
  >
    <EventClockMinuteInput
      class="w-11"
      inputClass="text-right border-transparent focus-within:border-neutral-dark-0 focus-within:border bg-neutral-light-6"
      size="xs"
      width="full"
    />
    <span class="font-semibold">:</span>
    <EventClockSecondInput
      class="w-7"
      inputClass="text-left border-transparent focus-within:border-neutral-dark-0 focus-within:border bg-neutral-light-6"
      size="xs"
      width="full"
    />
    <EventClockPlayPauseButton
      class="border-0"
      size="sm"
      square
    />
  </div>
</template>
